import React from 'react'
import PropTypes from 'prop-types'
import { Dialog } from '@mui/material'

import './CDialog.css'
import CIconButton from './CIconButton'
import Icon from './Icon'

const CDialog = ({
    open = false,
    onClose,
    title = '',
    children,
    actions = null,
    maxWidth = 'sm',
    fullWidth = true,
    className = '',
    showCloseButton = true,
    titleIcon = null,
    ...props
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={maxWidth}
            fullWidth={fullWidth}
            className={`c-dialog ${className}`}
            {...props}
        >
            <div className="c-dialog-container">
                {title && (
                    <div className="c-dialog-header">
                        {titleIcon && (
                            <div className="c-dialog-title-icon">
                                <Icon name={titleIcon} />
                            </div>
                        )}
                        <span className="c-dialog-title header-3">{title}</span>
                        {showCloseButton && (
                            <CIconButton
                                icon="close"
                                onClick={onClose}
                            />
                        )}
                    </div>
                )}
                <div className="c-dialog-content">{children}</div>
                {actions && <div className="c-dialog-actions">{actions}</div>}
            </div>
        </Dialog>
    )
}

CDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string,
    children: PropTypes.node,
    actions: PropTypes.node,
    maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    fullWidth: PropTypes.bool,
    className: PropTypes.string,
    showCloseButton: PropTypes.bool,
    titleIcon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ]),
}

export default CDialog
